export const authScopes = [
  'openid',
  'do:organization:read',
  'do:facility:read',
  'do:digital-order:read',
  'do:digital-order:upsert',
  'do:digital-order:delete',
  'do:digital-order:read:all',
];
